/**
 * Where to send somebody who does not belong in this application.
 *
 * **This is the sign-in path only**, for an account that turns out to be a mailbox rather than an
 * administrator. It is a path, not a host, and it works because `/mail/*` redirects to the mail client's
 * own host on every name the admin panel answers on — `<hostname>`, `postmaster.`, and the bare `:80`
 * with `tls.mode=none` (ADR 0031) — which is the one thing the admin panel can rely on without
 * knowing where that host is. The arrival is anonymous there: a mailbox owner signs in at the mail
 * client's own front door, which is where they should have started.
 *
 * **An administrator going to read mail does not come through here.** That is a hand-off, minted by
 * the server, which knows the mail client's hostname and hands back an absolute URL carrying a
 * single-use token (ADR 0032) — so an administrator arrives already signed in rather than at a second
 * login screen. See `useOpenWebmail` and `useOpenOwnWebmail`.
 */
export const WEBMAIL_SIGN_IN = '/mail';
